import { render, staticRenderFns } from "./v-magazine.vue?vue&type=template&id=19fd262d&scoped=true&"
import script from "./v-magazine.vue?vue&type=script&lang=js&"
export * from "./v-magazine.vue?vue&type=script&lang=js&"
import style0 from "./v-magazine.vue?vue&type=style&index=0&id=19fd262d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd262d",
  null
  
)

export default component.exports